import gameData from "../../gameData.js";
import TrayBaseColors from './trayBaseColors.js';

export default class DotTray extends TrayBaseColors
{
    constructor(scene, parentCont, type, ind)
    {
        super(scene, parentCont, type, ind);

        this.scene = scene;
        this.pCont = parentCont;
        this.type = type;
        this.ind = ind;

        this.isActive = false;

        this.createDotTray();

        this.setPosition(0, 0);
        this.scene.addToParent(this, this.pCont);
    }

    createDotTray()
    {
       for(let i=0;i<13;i++){
            let dot = this.scene.addButton(0, 0, "dot", null, ()=>{
                this.scene.playSound("select_color_pattern_face");

                dot.tintColor = gameData.dotColors[i];

                if(this.type === "trim") {
                    this.scene.faceMask.tintMask(dot.tintColor, "trim");
                }
                else if(this.type === "bg") {
                    this.scene.faceMask.setFace();
                    this.scene.faceMask.setPattern();
                    this.scene.navbar.clearActiveTrays();
                    this.scene.faceMask.tintMask(dot.tintColor, "mask");
                }
                
                this.tweenInCursor(dot.tintColor);
            }, this);

            dot.tint = gameData.dotColors[i];
            dot.x = i%2 ? 30 : 85;
            dot.y = -300 + (50*i);

            this.dots.push(dot);
        }
    }

    cleanUp()
    {
        this.cursor.destroy();
        this.dots.forEach(dot => {dot.destroy();});
        this.nameplate.destroy();
        this.nameplateText.destroy();
    }
}